import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';

import useTableFilter from '../../../components/TableFilter/useTableFilter';
import StaticTablePaginated from '../../../_ui/Table/StaticTablePaginated';
import { StyledTableContainer } from '../../Requests/RequestsStyles';
import { history } from '../../../_helpers/history';
import '../SupplierDataChangeTranslate';
import { notificationsColumns } from './SupplierDataChangeNotificationColumns';
import AnnulNotificationModal from './AnnulNotificationModal';
import {
  loadNotifications,
  annulNotification,
  supplierDataChangeModule
} from '../SupplierDataChangeDucks';

function SupplierDataChangeNotification({
  data,
  loading,
  annulLoading,
  loadNotifications,
  annulNotification
}) {
  const { t, i18n } = useTranslation();
  const { filter } = useTableFilter(loadNotifications);
  const [annulRow, setAnnulRow] = useState(null);

  const handleConfirm = async () => {
    const ok = await annulNotification(annulRow.serviceProviderId, filter);
    if (ok) setAnnulRow(null);
  };

  const handleChangeAddress = row => {
    history.push('/services/create/change_location_short', {
      serviceProviderBin: row.serviceProviderBin,
      serviceProviderId: row.serviceProviderId,
      serviceProviderRuName: row.serviceProviderRuName,
      serviceProviderKkName: row.serviceProviderKkName,
      serviceProviderLegalLocality: row.serviceProviderLegalLocality
    });
  };

  return (
    <div className="mt3 mb3 fullWidth">
      <Typography
        children={t('supplierDataChange_notificationsTitle')}
        color="secondary"
        variant="h6"
      />
      <StyledTableContainer>
        <div className="mt2">
          <StaticTablePaginated
            pageNumber={data.pageNumber}
            loading={loading}
            data={data.content}
            totalElements={data.totalElements}
            columns={notificationsColumns({
              pageNumber: data.pageNumber,
              lang: i18n.language,
              onAnnul: setAnnulRow,
              onChangeAddress: handleChangeAddress
            })}
            filterable={false}
            pagePagination={page => {
              if (page !== data.pageNumber) {
                loadNotifications({ ...filter, pageNumber: page });
              }
            }}
          />
        </div>
      </StyledTableContainer>
      <AnnulNotificationModal
        open={!!annulRow}
        loading={annulLoading}
        onClose={() => setAnnulRow(null)}
        onConfirm={handleConfirm}
      />
    </div>
  );
}

export default connect(
  state => ({
    data: state[supplierDataChangeModule].notifications,
    loading: state[supplierDataChangeModule].notificationsLoading,
    annulLoading: state[supplierDataChangeModule].annulLoading
  }),
  {
    loadNotifications,
    annulNotification
  }
)(SupplierDataChangeNotification);
